const normalizeText = value => (typeof value === 'string' ? value.trim() : '')

const escapeHtml = value => value
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;')
  .replace(/'/g, '&#039;')

const formatText = value => escapeHtml(value).replace(/\r\n|\r|\n/g, '<br>')

export const normalizeSeatMarks = marks => {
  if (!Array.isArray(marks)) return []

  return marks.reduce((result, mark) => {
    if (!mark || typeof mark !== 'object') return result

    const type = normalizeText(mark.type)
    const label = normalizeText(mark.label)
    const validSource = mark.source === 'seat' || mark.source === 'event'
    const validPublicState = typeof mark.is_public === 'boolean' || mark.is_public === 0 || mark.is_public === 1
    if (!type || !label || !validSource || !validPublicState) return result

    result.push({
      type,
      label,
      comment: normalizeText(mark.comment),
      source: mark.source,
      is_public: mark.is_public === true || mark.is_public === 1,
    })

    return result
  }, [])
}

export const buildSeatMarksIndex = (items, { publicOnly = false } = {}) => {
  if (!Array.isArray(items)) return {}

  const index = {}
  items.forEach(item => {
    if (!item || typeof item !== 'object' || item.seat_id === undefined || item.seat_id === null) {
      return
    }

    const marks = normalizeSeatMarks(item.marks)
      .filter(mark => !publicOnly || mark.is_public)

    if (marks.length) index[item.seat_id] = marks
  })

  return index
}

export const formatSeatMarksTooltip = (marks, { showMetadata = true } = {}) => {
  const groups = normalizeSeatMarks(marks).reduce((result, mark) => {
    const existingGroup = result.find(group => group.type === mark.type)
    if (existingGroup) {
      existingGroup.marks.push(mark)
    } else {
      result.push({
        type: mark.type,
        label: mark.label,
        marks: [mark],
      })
    }

    return result
  }, [])

  if (!groups.length) return ''

  const content = groups.map(group => {
    const entries = group.marks.map(mark => {
      const comment = mark.comment
        ? `<div class="seat-marks-tooltip__comment">${formatText(mark.comment)}</div>`
        : ''
      const metadata = showMetadata
        ? `<div class="seat-marks-tooltip__metadata">${mark.source === 'event' ? 'Мероприятие' : 'Зал'} · ${mark.is_public ? 'Публичное' : 'Скрыто'}</div>`
        : ''

      return comment || metadata
        ? `<div class="seat-marks-tooltip__entry">${comment}${metadata}</div>`
        : ''
    }).join('')

    return `<div class="seat-marks-tooltip__group"><div class="seat-marks-tooltip__label"><span class="seat-marks-tooltip__icon" aria-hidden="true">!</span><span>${formatText(group.label)}</span></div>${entries}</div>`
  }).join('')

  return `<div class="seat-marks-tooltip">${content}</div>`
}
